'use client';

import { c as _c } from "react/compiler-runtime";
import { Progress as ProgressPrimitive } from 'radix-ui';
import * as React from 'react';
import { cn } from '@/lib/utils';
function Progress(t0) {
  const $ = _c(13);
  let className;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      value,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = value;
  } else {
    className = $[1];
    props = $[2];
    value = $[3];
  }
  const indeterminate = value === undefined || value === null;
  const t1 = indeterminate && "animate-pulse";
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cn("relative h-2 w-full overflow-hidden rounded-full bg-primary/20", t1, className);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `translateX(-${100 - (value ?? 0)}%)`;
  let t4;
  if ($[7] !== t3) {
    t4 = <ProgressPrimitive.Indicator data-slot="progress-indicator" className="h-full w-full flex-1 bg-primary transition-all" style={{
      transform: t3
    }} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props || $[10] !== t2 || $[11] !== t4) {
    t5 = <ProgressPrimitive.Root data-slot="progress" className={t2} {...props}>{t4}</ProgressPrimitive.Root>;
    $[9] = props;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export { Progress };